import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { DialogueBloc } from '@kp/dialogue/dialogue.bloc';
import { DialogueStatus } from '@kp/dialogue/models/dialogue-data-status.model';
import { DialogueLogicKey } from '@kp/dialogue/models/dialogue.model';
import { OnboardingBloc } from '@kp/onboarding/onboarding.bloc';
import { Status } from '@ktypes/models';
import { Observable, of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OnboardingDialogueAvailableGuard {
  constructor(private _dialogueBloc: DialogueBloc, private _onboardingBloc: OnboardingBloc, private _router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean | UrlTree> {
    if (!this._onboardingBloc.isOnboarding) {
      return true;
    }
    this._dialogueBloc.getDialogueStatus(DialogueLogicKey.dialogue_purposeful_onboarding_v1);
    return this._dialogueBloc.dialogueStatus$.pipe(
      filter((dataStatus) => dataStatus?.status !== Status.starting && dataStatus?.data != null),
      map(
        (dialogueDataStatus) =>
          dialogueDataStatus?.data?.dialogueStatus !== DialogueStatus.completed ||
          this._router.parseUrl('/login/existing_account')
      ),
      catchError((error) => {
        console.warn('There was an error trying to check for the onboarding dialogue status', error);
        return of(this._router.parseUrl('/welcome/error'));
      })
    );
  }
}
